module.exports = require('../dist/compat/util/times.js').times;
